import React from "react";
import RadioInput from "features/shared/components/radioInput/RadioInput";
import IDataFilterRadioInputValue from "./IDataFilterRadioInputValue";
import IDataFilterProps from "../IDataFilterProps";
import { useTranslation } from "react-i18next";
import { getTranslatedFormText } from "features/shared/helpers/translationHelper";

const DataFilterRadioInputBox = (props: IDataFilterProps) => {
    // translations
  const tLables = useTranslation("shared\\dataFilters").t;
    
    const htmlRadioValue = (props.filterDescriptor.value as IDataFilterRadioInputValue);

    const setDescriptorValue = (name: string, value: string) => {
        const newDescriptors = [...props.descriptors];

        // Získám descriptor
        const descriptor = newDescriptors.find((x) => x.name === name);

        // Nastavím hodnotu
        let selectedValue = descriptor?.value as IDataFilterRadioInputValue;
        selectedValue.value = value;

        props.setDescriptors(newDescriptors);
    };

    const handleHtmlRadioOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const name = event.target.name;
        const value = event.target.value;

        setDescriptorValue(name, value);
    }

    return <RadioInput
        key={props.reactKey}
        name={props.filterDescriptor.name}
        label={getTranslatedFormText(props.filterDescriptor, "label", tLables)}
        data={htmlRadioValue.options}
        selectedValue={htmlRadioValue.value}
        onChange={handleHtmlRadioOnChange}
    />
}

export default DataFilterRadioInputBox;